<template>
  <div>
    <el-dropdown @command="command">
      <slot name="actions-trigger">
        <span class="el-dropdown-link more">
          <i class="eden-icon-more"></i>
        </span>
      </slot>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :icon="'eden-icon-user'" :command="'status'"
          >Change Rider Status</el-dropdown-item
        >
        <el-dropdown-item :icon="'eden-icon-settings'" :command="'password-reset'"
          >Reset password</el-dropdown-item
        >
        <el-dropdown-item :icon="'eden-icon-delete'" :command="'delete'"
          >Delete Rider</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <component
      :is="action.component"
      :show.sync="action.visibility"
      :rider="rider"
      @success="$emit('update', action.command)"
    />
  </div>
</template>

<script>
export default {
  name: "RiderActions",
  props: {
    rider: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    RiderDelete: () => import("./RiderDelete"),
    RiderStatus: () => import("./RiderStatus"),
    RiderPasswordReset: () =>  import("./RiderPasswordReset"),
  },

  data() {
    return {
      action: {
        component: "",
        command: "",
        visibility: false,
      },
    };
  },
  methods: {
    command(command) {
      this.action.component = `rider-${command}`;
      this.action.command = command;
      setTimeout(() => {
        this.action.visibility = true;
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped></style>
